import { useMemo } from "react";

import { useQuery } from "@apollo/client";

import { useSelectedOrganizationContainer } from "../../shared/hooks";
import { type ApolloResult } from "../../shared/models";
import { getOrganizationAssets } from "../api/queries/getOrganizationAssets";
import { type GetOrganizationAssetsQuery } from "../api/queries/getOrganizationAssets.gql-generated";
import { type AssetResponse } from "../types/assets";

interface OrganizationAssetsResult {
    organizationAssets: AssetResponse[];
    total?: number;
}

export const useOrganizationAssets = (): ApolloResult<OrganizationAssetsResult> => {
    const { orgId } = useSelectedOrganizationContainer();
    const { data, loading, error } = useQuery<GetOrganizationAssetsQuery>(getOrganizationAssets, {
        skip: !orgId,
        variables: {
            organizationId: orgId,
            limit: 1000,
        },
    });

    return useMemo(() => {
        return {
            loading,
            error,
            organizationAssets: [...(data?.getMyLensesOrganizationAssets.items ?? [])],
            total: data?.getMyLensesOrganizationAssets.total,
        };
    }, [loading, error, data?.getMyLensesOrganizationAssets]);
};
